export default __webpack_public_path__ + "static/media/gold_button.366ba39f.png";